<template>
    <font-awesome-icon :class="classByVote(value)" :icon="iconByVote(value)" fixed-width />
</template>

<script>
export default {
    name: "MatVoteIcon",
    props: {
        value: [Number, null]
    },
    methods: {
        classByVote(vote) {
            switch (vote) {
                case -1:
                    return "text-danger";

                case 0:
                    return "text-secondary";

                case 1:
                    return "text-success";
            }
        },
        iconByVote(vote) {
            switch (vote) {
                case -1:
                    return ['fas', "times"];

                case 0:
                    return ['fas', "equals"];

                case 1:
                    return ['fas', "check"];

                case null:
                    return ['far', 'circle'];
            }
        }
    }
}
</script>

<style scoped>

</style>